// extracted by mini-css-extract-plugin
export var audioPlayer = "_qb-0";